(() => {
  const acrylicHandle = 'premium-pokemon-etb-acrylic-case-magnetic-lid-uv-safe-elite-trainer-box-case';
  const petHandle = 'clear-pet-etb-protectors-compatible-with-pokemon-elite-trainer-boxes-0-50-mm-uv-protected';
  let timer;

  function itemHandle(item) {
    if (item.handle) return item.handle;
    const url = item.url || item.product_url || '';
    const match = url.match(/\/products\/([^?/#]+)/);
    return match ? match[1] : '';
  }

  function upsellFor(handles) {
    const hasAcrylic = handles.includes(acrylicHandle);
    const hasPet = handles.includes(petHandle);

    if (hasAcrylic && !hasPet) {
      return {
        key: 'pet',
        eyebrow: 'Protect the rest of the shelf',
        title: 'Need protection for more ETBs?',
        copy: 'Keep your centerpiece ETB in acrylic and use clear PET protectors for the rest of your sealed collection.',
        href: '/products/' + petHandle,
        link: 'Shop PET ETB protectors →'
      };
    }

    if (hasPet && !hasAcrylic) {
      return {
        key: 'acrylic',
        eyebrow: 'Upgrade one centerpiece',
        title: 'Want a premium acrylic display?',
        copy: 'Use PET for the collection and give your favorite sealed ETB a rigid acrylic display with a six-magnet lid.',
        href: '/products/' + acrylicHandle,
        link: 'See the acrylic ETB display case →'
      };
    }

    return null;
  }

  async function updateUpsell() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const footer = drawer.querySelector('.drawer__footer');
    if (!footer) return;

    let cart;
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      cart = await response.json();
    } catch (_) {
      return;
    }

    const handles = (cart.items || []).map(itemHandle);
    const offer = upsellFor(handles);
    const existing = footer.querySelector('.hgg-cart-upsell');

    if (!offer) {
      if (existing) existing.remove();
      return;
    }

    if (existing && existing.dataset.hggOffer === offer.key) return;
    if (existing) existing.remove();

    const box = document.createElement('div');
    box.className = 'hgg-cart-upsell';
    box.dataset.hggOffer = offer.key;

    const eyebrow = document.createElement('p');
    eyebrow.className = 'hgg-cart-upsell__eyebrow';
    eyebrow.textContent = offer.eyebrow;

    const title = document.createElement('p');
    title.className = 'hgg-cart-upsell__title';
    title.textContent = offer.title;

    const copy = document.createElement('p');
    copy.className = 'hgg-cart-upsell__copy';
    copy.textContent = offer.copy;

    const link = document.createElement('a');
    link.className = 'hgg-cart-upsell__link';
    link.href = offer.href;
    link.textContent = offer.link;

    box.append(eyebrow, title, copy, link);

    const checkout = footer.querySelector('.cart__ctas');
    if (checkout && checkout.parentNode) checkout.parentNode.insertBefore(box, checkout);
    else footer.appendChild(box);
  }

  function scheduleUpdate() {
    clearTimeout(timer);
    timer = setTimeout(updateUpsell, 180);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateUpsell);
  else updateUpsell();

  const observer = new MutationObserver(scheduleUpdate);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('click', scheduleUpdate, true);
})();
